<template>
  <!-- HEADER AND EMERGENCY BUTTON -->
  <div class="d-flex justify-content-between rounded-30 gap-2 flex-wrap">
    <h3>{{ pageTitle }}</h3>
    <div
      class="d-flex justify-content-end gap-4 visitor-check-ins-header-actions"
    >
      <LoadingButton
        v-if="
          !isBrowserNotificationEnabledFromStore &&
          !isBrowserNotificationEnabled()
        "
        rounded
        @click="enableBrowserNotification"
      >
        Enable Notifications
      </LoadingButton>
      <EmergencyButton
        prepend-icon="ri-alarm-warning-line"
        rounded
        @click="onEmergencyButton"
      >
        Alert
      </EmergencyButton>
    </div>
  </div>
  <!-- HEADER AND EMERGENCY BUTTON -->
</template>

<script>
import visitorUtils from "@/helpers/visitorUtils"
import visitorConfigs from "@/configs/visitorConfigs"
import visitorConstants from "@/constants/visitorConstants"
import EmergencyButton from "@/v3components/shared/Buttons/EmergencyButton.vue"
import LoadingButton from "@/v3components/shared/Buttons/LoadingButton.vue"
import { computed, defineAsyncComponent, inject } from "vue"
import { useStore } from "vuex"

const VisitorSendAlertPopUp = defineAsyncComponent(
  () =>
    import("@/v3components/Forms/Visitor/CheckIns/VisitorSendAlertPopUp.vue")
)

const staticData = {
  emergency: {
    settingId: visitorConstants.SETTINGS.EMERGENCY,
    alertType: visitorConstants.ALERTS.EMERGENCY
  },
  offender: {
    settingId: visitorConstants.SETTINGS.SEX_OFFENDER,
    alertType: visitorConstants.ALERTS.SEX_OFFENDER
  },
  watchlist: {
    settingId: visitorConstants.SETTINGS.WATCHLIST,
    alertType: visitorConstants.ALERTS.WATCHLIST
  }
}

export default {
  name: "VisitorCheckInsAndLogsHeader",
  components: {
    EmergencyButton,
    LoadingButton
  },
  setup() {
    const store = useStore()
    const modal = inject("modal")

    const currentMatch = computed(
      () => store?.getters?.["visitorManage/matchType"] || "emergency"
    )

    const isBrowserNotificationEnabledFromStore = computed(() => {
      return (
        store?.getters?.["visitorSettings/isBrowserNotificationEnabled"] ||
        false
      )
    })

    const school = computed(() => store.getters["visitorSettings/school"])

    const visitorSchoolData = computed(() => {
      return school?.value?.data || null
    })

    const alertSetting = computed(() => {
      return visitorSchoolData.value?.building_settings?.find(
        (setting) =>
          setting.settings_id === staticData[currentMatch.value].settingId
      )
    })

    const isAlertSettingActive = computed(() => {
      return alertSetting.value?.value === "true"
    })

    const capitalizeCurrentMatch = computed(() => {
      return currentMatch.value
        ? currentMatch.value.charAt(0).toUpperCase() +
            currentMatch.value.slice(1)
        : ""
    })

    const setCurrentMatchType = (type = "emergency") => {
      store.commit(
        "visitorManage/SET_MATCH_TYPE",
        type?.trim()?.toLowerCase() || "emergency"
      )
    }

    const onEmergencyButton = () => {
      setCurrentMatchType("emergency")

      const mapForArticle = {
        emergency: "an",
        offender: "an",
        watchlist: "a"
      }
      modal.open(VisitorSendAlertPopUp, {
        size: "sm",
        title: isAlertSettingActive.value ? "Alert" : "Notification not sent",
        props: {
          isAlertActive: isAlertSettingActive.value,
          title: isAlertSettingActive.value ? "Alert" : "Notification not sent",
          body: isAlertSettingActive.value
            ? `Do you want to send ${mapForArticle?.[currentMatch.value] || ""} alert? This cannot be undone.`
            : `Please check alert configurations. Contact your admin to update Security Alerts`,
          type: currentMatch.value
        }
      })
    }

    return {
      pageTitle: visitorConfigs.pages.checkInLogsPage().name,
      onEmergencyButton,
      capitalizeCurrentMatch,
      isBrowserNotificationEnabledFromStore,
      isBrowserNotificationEnabled:
        visitorUtils.forSettings.isBrowserNotificationEnabled,
      enableBrowserNotification:
        visitorUtils.forSettings.enableBrowserNotification
    }
  }
}
</script>

<style scoped></style>
